import React ,{ useEffect, useRef } 
from "react";
import { FormProvider, useForm } from "react-hook-form";

import { IFilterCompte, getDefaultFilterCompte } from "../../../models/interfaces/IFilterCompte";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import TextInput from "../../../components/forms/TextInput";
import { typeCompteList, typeCompteStatus, validationMode } from "../../../config/helpers";
import DatePickerInput from "../../../components/forms/DatePickerInput";
import { MESSAGE_PLACEHOLDER_CHOIX_DATE } from "../../../data/message-placeholders";
import SelectInput from "../../../components/forms/SelectInput";
import { IFilterCompteBO } from "../../../models/interfaces/IFilterCompteBO";
import CpntFilterButtons from "../../../components/CpntFilterButtons";



interface IProps {
  filter?: IFilterCompte;
  changeFilter: (data: IFilterCompte) => void;
}


//Arrive pas a faire passer unb param au parent...
const ComptesBOFilter: React.FC<IProps> = ({ filter, changeFilter }) => {

  const prevFilterRef = useRef<IFilterCompteBO | undefined>(filter);
  useEffect(() => {
    if (JSON.stringify(prevFilterRef.current) !== JSON.stringify(filter) || getValues() !== JSON.stringify(filter)) {
      reset(filter);
    }
    prevFilterRef.current = filter;
  }, [filter]);

  
  const formMethods = useForm<IFilterCompte>({
    defaultValues: getDefaultFilterCompte(),
  });

  const { handleSubmit, reset,getValues,watch } = formMethods;
  const watchDates = watch(["DateDebut", "DateFin"]);


  const handleResetForm = () => {
    localStorage.removeItem("IFilterComptes");
    changeFilter(getDefaultFilterCompte());

    reset(getDefaultFilterCompte()); // Réinitialise explicitement le formulaire
  };

  const handleSubmitForm = () => {
    handleSubmit(onSubmit)();
  };


  const onSubmit = (data: IFilterCompteBO) => {
    changeFilter(data);
    localStorage.setItem("IFilterComptes",JSON.stringify(data)); //need ??
  };


  const handleKeyPress = (e: { key: string; preventDefault: () => void; }) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      //SubmitButton.current.click();
    }
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={handleKeyPress} >
        <CpntFormSection pSectionLabel="Filtres">
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[2,3,2,3,2]}>
          <TextInput
              label="Raison sociale"
              formName="RaisonSociale"
              validationStyle={validationMode.none}
              placeholder="Raison sociale"
            />
            <TextInput
              label="Siren"
              formName="Siren"
              validationStyle={validationMode.none}
              placeholder="Siren"
            />
            <TextInput
              label="Nom prénom"
              formName="NomPrenom"
              validationStyle={validationMode.none}
              placeholder="Nom prénom"
            />
            <TextInput
              label="Email"
              formName="Email"
              validationStyle={validationMode.none}
              placeholder="Email"
            />
             <TextInput
              label="Id"
              formName="Id"
              validationStyle={validationMode.none}
              placeholder="Id"
            />
          </CpntFormSectionContainer>
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[3,3,3,3, 12]}>
            <DatePickerInput
              label="Création après le"
              formName="DateDebut"
              maxDate={watchDates[1] ? watchDates[1] : new Date()}
              validationStyle={validationMode.none}
              placeholder={MESSAGE_PLACEHOLDER_CHOIX_DATE}
            />
            <DatePickerInput
              label="Création avant le"
              formName="DateFin"
              minDate={watchDates[0]}
              maxDate={new Date()}
              validationStyle={validationMode.none}
              placeholder={MESSAGE_PLACEHOLDER_CHOIX_DATE}
            />
            <SelectInput
                 label="Statut"
                 formName="IdStatusUtilisateur"
                 //supprimer ces nullValues car ça sert à rien ils ne sont pas séléctionner déjà
                 //nullValue="Sélectionner Status"
                 validationStyle={validationMode.none}
                 options={typeCompteStatus.map((tc) => {
                 return {
                    Id: tc.Id,
                    Libelle: tc.Libelle,
                        };
                 })}
            />
            <SelectInput
                 label="Type d'utilisateur"
                 formName="IdTypeUtilisateur"
                 //nullValue="Sélectionner Type d'utilisateur"
                 validationStyle={validationMode.none}
                 options={typeCompteList.map((tc) => {
                  return {
                     Id: tc.Id,
                     Libelle: tc.Libelle,
                         };
                  })}
            />
            <CpntFilterButtons  
              resetForm={handleResetForm}
              submitForm={handleSubmitForm}
            />
          </CpntFormSectionContainer>
        </CpntFormSection>
      </form>
    </FormProvider>
  );
};

export default ComptesBOFilter;
